<template>
  <div id="app">
  <router-view></router-view>
  </div>
</template>

<script>
import { updateDocumentMeta } from './router'
export default {
  name: 'app',
  watch: {
    '$lang' () {
      updateDocumentMeta(this.$router.currentRoute)
    }
  }
}
</script>

<style>
</style>
